/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import callAPI from './callAPI';

export function getTokenList(args) {
  return callAPI({ endpoint: '/tokens', method: 'get', query: args });
}

export function editToken(id, name, aux) {
  let aux1;
  if (!_.isNil(aux)) {
    aux1 = JSON.stringify(aux);
  }
  return callAPI({ endpoint: `/tokens/${id}`, method: 'put', query: {}, body: { name, aux: aux1 } });
}

export function addtoken(name) {
  return callAPI({ endpoint: '/tokens', method: 'post', query: {}, body: { name } });
}

export function deleteToken(id) {
  return callAPI({ endpoint: `/tokens/${id}`, method: 'delete', query: {}, body: {} });
}




// WEBPACK FOOTER //
// ./src/api/token.js